






export default {
  props: {
    tooltipText: { type: String, required: true },
    customClass: { type: String, default: '' }
  }
}
